<div class="auth-layout">
  <main class="auth-main">
    <router-outlet></router-outlet>
  </main>
</div>
